import React from 'react';
import CustomSteps from './CustomSteps';

import { Step } from '../../services/util/step-manager/types/Step';

type Props = {
  currentStep: Step;
  onChangeStep: (current: number) => void;
};

const StepCombined: React.FC<Props> = ({ currentStep, onChangeStep }) => {

  return <CustomSteps currentStep={currentStep} onChangeStep={onChangeStep} />;
};

export default StepCombined;
